const LOAD_ALARMS = 'ALARMS_HISTORY/LOAD';
const LOAD_ALARMS_WITH_FILTER = 'ALARMS_HISTORY/LOAD_ALL_FILTERED';
const CHANGE_ALARMS_ORDER = 'ALARMS_HISTORY/CHANGE_ORDER';
const CHANGE_ALARMS_FILTER = 'ALARMS_HISTORY/CHANGE_FILTER';

export { LOAD_ALARMS, LOAD_ALARMS_WITH_FILTER, CHANGE_ALARMS_ORDER, CHANGE_ALARMS_FILTER };
